<template>
  <div>
  
    <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="Dino claimed Points" active>
                <hr>
                <Dinoclaimed></Dinoclaimed>
              </CTab>
              <CTab title="Dino unclaimed Points">
                <hr>
              <Dinounclaimed></Dinounclaimed>
              </CTab>
              <CTab title="Dino Points Entry">
                <hr>
              <DinopointEntry></DinopointEntry>
              </CTab>
                <CTab title="Dino Daily Updates">
                <hr>
              <DinoDailyLimit></DinoDailyLimit>
              </CTab>
            </CTabs>
        
      </CCol>
    
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Dinoclaimed from "./dinoclaimed.vue"
import Dinounclaimed from "./dinounclaimed.vue"
import DinopointEntry from "./dinopointEntry.vue"
import DinoDailyLimit from "./dinoDailyLimit.vue"
export default {
  components: {
    Dinoclaimed,
    Dinounclaimed,
    DinopointEntry,
    DinoDailyLimit
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
   
     
    };
  },
  watch: {
   
  },
  methods: {
    
    // sendmsg(){}
  },
  created() {

  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>